"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidConnectFlow/steps/PlaidExitRetentionPortfolioStep";

import React from "react";
import { Icon } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidExitRetentionPortfolioStepProps {
  onContinueConnect: () => void;
  onAddManuallyInstead: () => void;
  onConfirmExit: () => void;
  onClose?: () => void;
  /** Onboarding 入口隐藏手动新增（仅允许 Plaid） */
  showAddManually?: boolean;
}

export const PlaidExitRetentionPortfolioStep: React.FC<
  PlaidExitRetentionPortfolioStepProps
> = ({
  onContinueConnect,
  onAddManuallyInstead,
  onConfirmExit,
  onClose,
  showAddManually = true,
}) => {
  return (
    <div
      className="flex-1 flex flex-col items-center justify-center p-4 bg-background_black_overlay50 backdrop-blur-sm overflow-y-auto"
      onClick={onClose}
      data-openreplay-label="plaidconnectflow_retention_portfolio_close"
    >
      {/* or-label: n/a —— stopPropagation，关闭在遮罩层已采集 */}
      <div
        className="relative w-full max-w-[300px] bg-background_solid_secondary text-content_primary rounded-xl pt-8 pb-6 px-6 shadow-2xl flex flex-col items-center gap-6"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Intro Block */}
        <div className="flex flex-col items-center text-center gap-3 w-full">
          {/* Wallet Icon in Disc */}
          <div className="size-[72px] rounded-full bg-background_brand_overlay10 text-content_brand_primary flex items-center justify-center shrink-0">
            <Icon name="wallet" size={36} />
          </div>

          {/* Text Block */}
          <div className="flex flex-col gap-2 w-full text-center">
            <h2 className="font-['Lexend'] text-[20px] font-normal text-content_primary leading-7 tracking-[-0.8px]">
              {I18n.t("Connect an account to run portfolio checkup")}
            </h2>
            <p className="text-sm text-content_secondary leading-5 font-normal">
              {I18n.t(
                "This checkup reads your real holdings. Connect one and I'll run it.",
              )}
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 w-full">
          {/* 1. Primary: Connect account */}
          <button
            type="button"
            onClick={onContinueConnect}
            data-openreplay-label="plaid_exit_retention_portfolio_connect"
            className="w-full h-11 rounded-lg bg-background_brand_overlay100 text-content_inverse_primary font-medium text-sm hover:opacity-90 active:scale-[0.99] transition-all cursor-pointer flex items-center justify-center shadow-sm"
          >
            {I18n.t("Connect account")}
          </button>

          {/* 2. Secondary: Add manually；onboarding 仅允许 Plaid */}
          {showAddManually && (
            <button
              type="button"
              onClick={onAddManuallyInstead}
              className="w-full h-11 rounded-lg bg-transparent border border-border_solid text-content_primary font-medium text-sm hover:bg-background_solid_tertiary active:scale-[0.99] transition-all cursor-pointer flex items-center justify-center shadow-sm"
              data-openreplay-label="plaid_exit_retention_portfolio_add_manually"
            >
              {I18n.t("Add manually")}
            </button>
          )}

          {/* 3. Tertiary: Change another checkup */}
          <button
            type="button"
            onClick={onConfirmExit}
            data-openreplay-label="plaid_exit_retention_portfolio_not_now"
            className="w-full h-11 rounded-lg text-content_tertiary hover:text-content_primary font-medium text-sm transition-colors cursor-pointer flex items-center justify-center"
          >
            {I18n.t("Change another checkup")}
          </button>
        </div>
      </div>
    </div>
  );
};
